/**
 * package: com.inq.ui
 * class: LineInput
 * @extends com.inq.ui.AbstractTextInput 
 * @constructor
 */
com.inq.ui.LineInput = function(_id) {
	com.inq.ui.AbstractTextInput.call(this,_id);
	this._div.innerHTML = "<input type=\"text\" style=\"height:100%;width:100%\"></input>";
	this.setupInput(this._div.getElementsByTagName("input")[0]);
};
$hxClasses.extend(com.inq.ui.AbstractTextInput, com.inq.ui.LineInput, "com.inq.ui.LineInput");

/**
 * buildStyle
 *
 * @override
 * @private
 * @this com.inq.ui.LineInput
 * @return {void}
 */
com.inq.ui.LineInput.prototype.buildStyle = function() {
	com.inq.ui.AbstractTextInput.prototype.buildStyle.call(this);/* Call super class build style */
	if(this.styles.value != null) {
		/* Get the text area element */
		/** @type {HTMLInputElement} */
		var ln = this._div.getElementsByTagName("INPUT")[0];
		/* set the text input area with the evaluated text */
		ln.value = this.evaluateString(this.styles.value);
	}
};

/**
 * Getter for value of element.
 * @public
 * @returns {string}
 */
com.inq.ui.LineInput.prototype.getText = function() {
	return this._getInput();
};